import { ocapiV1Routes } from '../routes';
export const workstationsApiRoutes = {
    create: () => `${ocapiV1Routes.workstations}/registrations`,
    setCurrent: () => `${ocapiV1Routes.workstations}/current`,
    getCurrent: () => `${ocapiV1Routes.workstations}/current`
};
//# sourceMappingURL=routes.js.map